const url = '/audit/sicc/validaCertidaoLegada/revisao'

export function buscarLogPorValidaCertidaoLegada(id) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${id}`).then((res) => {
      resolve(res.data);
    });

    // const data = [
    //   { idenEmpresa: 13, nomeFantasia: "ODILON XPTO 2", razaoSocial: "ODILON XPTO 2444", descInscEstadual: "12145", cnpj: 88994843000100, auditoriaDTO: null },
    //   {
    //     idenEmpresa: 13,
    //     nomeFantasia: "ODILON XPTO",
    //     razaoSocial: "ODILON XPTO",
    //     descInscEstadual: "12145",
    //     cnpj: 88994843000100,
    //     auditoriaDTO: { id: 13, rev: 39, revtype: "ADD", ip: "0:0:0:0:0:0:0:1", usuario: "111780-ANDERSON", sistema: "SICC", ultimaVersao: false, dataFormatada: "26/04/2022 17:31:03", revtypeFormatada: "Adicionado" },
    //   },
    //   {
    //     idenEmpresa: 13,
    //     nomeFantasia: "ODILON XPTO 2",
    //     razaoSocial: "ODILON XPTO 2",
    //     descInscEstadual: "12145",
    //     cnpj: 88994843000100,
    //     auditoriaDTO: { id: 13, rev: 40, revtype: "MOD", ip: "0:0:0:0:0:0:0:1", usuario: "111780-ANDERSON", sistema: "SICC", ultimaVersao: false, dataFormatada: "26/04/2022 17:31:44", revtypeFormatada: "Alterado" },
    //   },
    //   {
    //     idenEmpresa: 13,
    //     nomeFantasia: "ODILON XPTO 2",
    //     razaoSocial: "ODILON XPTO 2444",
    //     descInscEstadual: "12145",
    //     cnpj: 88994843000100,
    //     auditoriaDTO: { id: 13, rev: 41, revtype: "MOD", ip: "0:0:0:0:0:0:0:1", usuario: "257812-MAX JORGE LACERDA DA MATTA", sistema: "SICC", ultimaVersao: true, dataFormatada: "27/04/2022 15:33:14", revtypeFormatada: "Alterado" },
    //   },
    // ];
    // resolve(data);
  });
}
